/* unplugin-vue-components disabled */import script from "./QuickWorker.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuickWorker.vue?vue&type=script&setup=true&lang=ts"

import "./QuickWorker.vue?vue&type=style&index=0&id=7ca97f3b&scoped=true&lang=less"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ca97f3b"]])

export default __exports__